import React from "react";
import { useRequest } from "@/components/pages/requests/hooks/useRequests";
import ChannelUserAvatar from "@/components/pages/chats/component/chat-custom-components/ChannelUserAvatar";
import { RoundTag } from "@/components/pages/chats/component/ui/RoundTag";
import { useAccessCapabilities } from "@/hooks/useAccessCapabilities";

interface RequestPreviewProps {
  requestId: string;
}

export const RequestPreview: React.FC<RequestPreviewProps> = ({
  requestId,
}) => {
  const { capabilities } = useAccessCapabilities();
  const { data: request, isLoading } = useRequest(
    requestId,
    capabilities.canUseRequestsSystem,
  );

  if (!capabilities.canUseRequestsSystem) return null;

  if (isLoading || !request) return null;

  const user = request.guest?.profile;
  const fullName = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim()
    : "";

  return (
    <div className="flex flex-row justify-between items-center w-full mt-1">
      <div className="flex items-center gap-2">
        <ChannelUserAvatar name={fullName} className="h-6 w-6 text-sm" />
        <span className="text-xs text-slate-600 truncate max-w-[150px]">
          {fullName}
        </span>
      </div>
      {request.service?.name && (
        <RoundTag className="bg-gray-500 text-white border-none py-1 px-2 h-fit">
          {request.service.name}
        </RoundTag>
      )}
    </div>
  );
};
